<template>
  <TheLoader :active="true" v-if="loading"/>
  <div class="content-container flex-row" v-else>
    <section class="content white">
      <TheLoader :active="updating" style="opacity:0.5"/>
      <TheEmptyList v-if="items.length < 1" :title="'Ingen objekter'" :large="true" :icon="'glyph-medium-object'"/>

      <table v-if="items.length > 0" class="large fixed sortable clickable evenodd contracts table-filter">
        <thead>
        <tr>
          <th v-for="(heading, index) in headings" v-bind:key="index"
              v-bind:class="[heading.class, heading.sortKey === queryParams.sort ? sortClass : '']"
              @click="changeSorting(heading.sortKey)">
            {{heading.name}}
            <span id="sorttable_sortrevind"
                  v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'desc'">&nbsp;</span>
            <span id="sorttable_sortfwdind"
                  v-if="heading.sortKey === queryParams.sort && queryParams.direction === 'asc'">&nbsp;</span>
          </th>
        </tr>
        </thead>

        <tbody>
        <tr v-for="item in items" v-bind:key="item.Objektid">
          <td colspan="1">
            <div class="flex-container">
              <div class="input-container checkbox">
                <input type="checkbox" :value="item.Objektid" v-model="selectedObjekter"  :disabled="selectedAvdeling != null && selectedAvdeling != item.Avdelingsid">
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
              <span class="thumbnail-container">
                <span class="thumbnail small placeholder animation">
                  <template v-if="objektThumb(item) && objektLarge(item)">
                    <img class="hi-trigger" :src="objektThumb(item)" :data-hi-src-full="objektLarge(item)" data-hi-size="large" />
                  </template>
                  <template v-else-if="objektThumb(item)">
                    <img :src="objektThumb(item)" />
                  </template>
                  <template v-else>
                    <span class="placeholder"></span>
                  </template>
                </span>
                <a href="javascript:;" class="primary-title">{{item.Objektnr}}</a>
              </span>
            </div>
          </td>

          <td class="show-for-large">
            {{item.title | truncate(40)}}
            <span class="opacity-60" v-if="item.subtitle"><br>{{item.subtitle | truncate(30)}}</span>
          </td>
          <td class="show-for-large" v-if="item.kategori">
            {{item.kategori.Kategori}}
          </td>
          <td v-else>-</td>
          <td class="show-for-large">{{item.avdeling ? item.avdeling.Beskrivelse : '-'}}</td>
          <td class="show-for-medium">
              <span class="opacity-60" v-if="item.Vurderingspris1>0 && item.Vurderingspris2>0">
                {{item.Vurderingspris2 | thousands}} - {{item.Vurderingspris1 | thousands}}
              </span>
            <span v-else>
                <span class="opacity-60" v-if="item.Vurderingspris1>0">
                  {{item.Vurderingspris1 | thousands}}
                </span>
                <span class="opacity-60" v-if="item.Vurderingspris2>0">
                  {{item.Vurderingspris2 | thousands}}
                </span>
              </span>
          </td>
          <td class="show-for-medium align-right">
              <span class="opacity-60">
                {{item.Salgspris | thousands}}
              </span>
          </td>
        </tr>
        </tbody>
      </table>

      <div class="pagination-container" v-if="pageCount > 1">
        <paginate v-model="currentPage"
          :page-count="pageCount"
          :page-range="11"
          :click-handler="changePage"
          :container-class="'pagination'"
          :prev-text="paginationArrow"
          :next-text="paginationArrow"
          :prev-class="'prev'"
          :next-class="'next'"
        ></paginate>
      </div>
      <div class="checkbox-panel-container" :class="{'active': selectedObjekter.length > 0}"
           style="width: calc(100% - 450px);padding-right: 0px;left: auto;right: calc(80px);">
        <div class="checkbox-panel">
          <div class="grid-x">
            <div class="cell auto">
              <div class="input-container checkbox">
                <input type="checkbox" id="checkall-objekter" @click="toggleSelectAll($event)" :checked="selectedObjekter.length === items.filter(x => selectedAvdeling == null || selectedAvdeling == x.Avdelingsid ).length">
                <label for="checkall-objekter">Marker alle</label>
                <span class="glyph"><svg viewBox="0 0 16 16"><use
                  xlink:href="/static/sprites.svg#glyph-input-checkbox"></use></svg></span>
              </div>
            </div>
            <div class="cell shrink">
              <span class="count"><span class="checked">{{selectedObjekter.length}}</span> / <span class="total">{{items.length}}</span> markert</span>
            </div>
            <div class="cell shrink">
              <a href="javascript:;" @click="invoiceMulti()" class="button secondary">Fakturer</a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import {mapGetters} from 'vuex'
import bus from '@/plugins/event-bus'

export default {
  name: 'KundeCardShowTabInvoiceObjekt',
  props: {
    kunde: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      currentPage: 1, // Just for the pagination component
      selectedObjekter: [],
      headings: [
        {name: 'Objekt', sortKey: 'Objektnr', class: ''},
        {name: 'Tittel', sortKey: '', class: 'show-for-large'},
        {name: 'Kategori', sortKey: 'Kategori', class: 'show-for-large'},
        {name: 'Avdeling', sortKey: 'avdeling.Beskrivelse', class: 'show-for-large'},
        {name: 'Vurdering', sortKey: 'Vurderingspris2', class: 'show-for-medium'},
        {name: 'Tilslag', sortKey: 'Salgspris', class: 'show-for-medium align-right'}
      ],
      loadedImages: {}
    }
  },
  created () {
    // Note: The fetch of items is done in KundeCard.
    this.currentPage = this.queryParams.page || 1
  },
  updated () {
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {
          })
        }
      }
    })
  },
  mounted () {
    console.log('this.items!', this.items.map(x => x.Avdelingsid))
    setTimeout(function () {
      if (window.jQuery('table.fixed') && window.jQuery('table.fixed').length > 0) {
        if (!window.jQuery('table.fixed').hasClass('sticky')) {
          window.jQuery('table.fixed').addClass('sticky')
          window.jQuery('table.fixed').stickyTableHeaders({fixedOffset: 200})
          window.jQuery(window).resize(function () {
          })
        }
      }
    })
  },
  computed: {
    ...mapGetters('kundeobjektbuyerinvoice', [
      'items',
      'pageCount',
      'queryParams',
      'loading',
      'updating'
    ]),
    selectedAvdeling: function () {
      if (this.selectedObjekter.length === 0) return null
      return this.items.find(x => x.Objektid === this.selectedObjekter[0]).Avdelingsid
    },
    sortClass: function () {
      return 'sorttable_sorted' + (this.queryParams.direction !== 'asc' ? '_reverse' : '')
    }
  },
  methods: {
    objektThumb: function (item) {
      if (item.photos && item.photos.thumb && item.photos.thumb.length > 0) {
        return item.photos.thumb[0]
      }

      return null
    },
    objektLarge: function (item) {
      if (item.photos && item.photos.large && item.photos.large.length > 0) {
        return item.photos.large[0]
      }

      return null
    },
    changePage: function (page) {
      var vm = this
      window.jQuery('html, body').animate({
        scrollTop: 0
      }, 200, function () {
        // Update a copy of the query params, to send to our store
        let copiedParams = vm._.clone(vm.queryParams)
        vm.currentPage = page
        copiedParams.page = vm.currentPage

        vm.$store.dispatch('kundeobjektbuyerinvoice/reload', {
          kundenr: vm.kunde.Kundenr,
          queryParams: copiedParams
        })
      })
    },
    changeSorting: function (sortKey) {
      if (!sortKey) {
        return
      }

      // Update a copy of the query params, to send to our store
      let copiedParams = this._.clone(this.queryParams)
      this.currentPage = 1
      copiedParams.page = this.currentPage

      if (copiedParams.sort === sortKey) {
        copiedParams.direction = copiedParams.direction === 'asc' ? 'desc' : 'asc'
      } else {
        copiedParams.direction = 'asc'
      }

      copiedParams.sort = sortKey

      this.$store.dispatch('kundeobjektbuyerinvoice/reload', {
        kundenr: this.kunde.Kundenr,
        queryParams: copiedParams
      })
    },
    toggleSelectAll: function (event) {
      let vm = this
      if (event.target.checked) {
        this.items.forEach(i => {
          if (this.selectedAvdeling === i.Avdelingsid && !vm.selectedObjekter.includes(i.Objektid)) {
            vm.selectedObjekter.push(i.Objektid)
          }
        })
      } else {
        // Just empty selected-array
        this.selectedObjekter = []
      }
    },
    invoiceMulti: function () {
      var vm = this

      if (!this.selectedObjekter) {
        this.$helpers.showErrorAlert('Feil', 'Vennligst velg ett eller flere objekter.')
        return
      }
      bus.$emit('switchKundeFakturerMultiple', vm.selectedObjekter)
    },
    showObjektItem: function (event, item) {
      let isCheckboxClick = event.target.nodeName === 'INPUT'

      window.jQuery('#hi-container').removeClass('active')
      window.jQuery(document).unbind('mousemove')

      if (!isCheckboxClick) {
        this.$router.push({
          name: 'KundeCard',
          params: {kunde_id: item.innlevav.Kundenr},
          query: {kontrakt: item.Kontraktnr, objekt: item.Objektid},
          hash: ''
        })
      }
    }
  }
}
</script>
<style scoped>
  input[disabled], input[disabled] + .glyph{
    opacity: 0 !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/Admin/KundeCardShowTabInvoiceObjekt.vue